<template>
    <div class="sign-in inverted">
        <div class="sign-in__wrapper">
            <div class="sign-in__bg">
                <div class="sign-in__form-wrapper">
                    <div class="sign-in__form">
                        <div class="sign-in__form-inside">
                            <div class="sign-in__form-inside-box">
                                <div class="sign-in__logo-wrapper">
                                    <img src="@assets/images/header/logo-nlb-buy&go.png" alt="NLB Buy&Go logo"
                                        class="sign-in__logo">
                                </div>

                                <div class="sign-in__form-content">
                                    <h1 class="sign-in__title">
                                        {{ $t(`LoginScreen.Title`) }}
                                    </h1>

                                    <!-- Sign in form -->
                                    <v-form @keyup.enter="loginSummit()">
                                        <!-- Username -->
                                        <div class="sign-in__row">
                                            <label class="form-label">
                                                {{ $t(`LoginScreen.Username`) }}
                                            </label>
                                            <v-text-field @update:modelValue="publicStore.SetUsername($event)"
                                                :modelValue="publicStore.Login.Username"
                                                hint="Vnesite e-mail ali telefonsko številko v formatu +386 xx xxxxxxxx."
                                                persistent-hint
                                                :error-messages="v$.Username.$errors[0] != null ? v$.Username.$errors[0].$message : ''"
                                                variant="outlined" @blur="validateUsername()"
                                                @focus="v$.Username.$reset">
                                            </v-text-field>
                                        </div>

                                        <!-- Password -->
                                        <div class="sign-in__row">
                                            <label class="form-label">
                                                {{ $t(`LoginScreen.Password`) }}
                                            </label>

                                            <v-text-field v-model="publicStore.Login.Password"
                                                :error-messages="!!v$.Password.$errors[0] ? v$.Password.$errors[0].$message : ''"
                                                hide-details="auto"
                                                variant="outlined" @focus="clearPasswordErrorOnFocus()"
                                                @blur="validatePassword()"
                                                :append-inner-icon="showPassword ? 'custom:iconPasswordVisible' : 'custom:iconPasswordNotVisible'"
                                                :type="showPassword ? 'text' : 'password'"
                                                @click:append-inner="showPassword = !showPassword">
                                            </v-text-field>
                                        </div>

                                        <!-- Error message -->
                                        <div v-if="publicStore.PublicHelpers.ServerError !== ''"
                                            class="notification notification--warning mt-4">
                                            {{ $t('GlobalErrors.' + publicStore.PublicHelpers.ServerError) }}
                                        </div>

                                        <!-- Še nimate računa? -->
                                        <!-- <div v-if="publicStore.PublicHelpers.ServerError !== ''" class="text-center panel-sign-in__no-account mb-10">
                                            {{ publicStore.PublicHelpers.UserExists ? 'Še nimate računa?' : 'Kliknite' }}
                                            <span @click="publicStore.toRegistration()" class="text-decoration-underline cursor-pointer">{{ publicStore.PublicHelpers.UserExists ? 'Registrirajte se' : 'tukaj' }} </span>
                                            <span v-if="!publicStore.PublicHelpers.UserExists"> in se registrirajte.</span>
                                        </div> -->

                                        <!-- Ste pozabili svoje geslo -->
                                        <div class="sign-in__password-reset mt-0">
                                            <span class="link" @click="publicStore.toPasswordChange()">
                                                {{ $t(`LoginScreen.LinkForgotPassword`) }}
                                            </span>
                                        </div>

                                        <!-- Sign in btn -->
                                        <v-btn @click="loginSummit()" flat
                                            class="btn btn--primary-fill btn--animated mt-4">
                                            {{ $t(`GeneralButtons.signIn`) }}
                                            <span class="icon-wrapper">
                                                <v-icon class="icon icon-current">mdi-arrow-right</v-icon>
                                                <v-icon class="icon icon-next">mdi-arrow-right</v-icon>
                                            </span>
                                        </v-btn>

                                        <div class="divider divider--horizontal"></div>

                                        <!-- Forgot pass link -->
                                        <div class="panel-sign-in__password-reset">
                                            V primeru, da potrebujete pomoč, nas lahko pokličete na telefonsko številko
                                            01 548 34 56.
                                        </div>

                                        <div class="sign-in-registration-text">
                                            <span class="me-3">Še nimate računa?</span>
                                            <v-btn @click="publicStore.toRegistration()" size="small" flat
                                                class="btn btn--primary-outline btn--sm btn--animated">
                                                {{ $t(`LoginScreen.registration_title`) }}
                                                <span class="icon-wrapper">
                                                    <v-icon class="icon icon-current">mdi-arrow-right</v-icon>
                                                    <v-icon class="icon icon-next">mdi-arrow-right</v-icon>
                                                </span>
                                            </v-btn>
                                        </div>

                                    </v-form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sign-in__image-curve-wrapper">
                    <div class="sign-in__image-curve"></div>
                </div>
                <div class="sign-in__image">
                    <img src="/images/image-login.jpg" alt="Login image" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, ComputedRef, Ref, ref } from "vue";
    import { helpers } from "@vuelidate/validators";
    import { i18n } from "@app/i18n";
    import { usePublicStore } from "@/app/store/public/public-store";
    import { useVuelidate } from "@vuelidate/core";
    import errors from "@/app/global-errors";

    const publicStore = usePublicStore();
    publicStore.PublicHelpers.ServerError = '';

    publicStore.$reset();

    const msisdnRegex = /^\+[1-9](?:[\s-]?\d){1,14}$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let visible: Ref<boolean> = ref(false);

    async function loginSummit() {
        await validateForm().then(() => {
            v$.value.$reset();
            publicStore.PortalLogin();
        });
    };

    async function validateUsername() {
        v$.value.Username.$touch();
        await v$.value.Username.$validate();
    }

    async function validatePassword() {
        v$.value.Password.$touch();
        await v$.value.Password.$validate();
    }

    function clearPasswordErrorOnFocus() {
        publicStore.PublicHelpers.ServerError = "";
        v$.value.Password.$reset();
    }

    function clearPhoneNumberErrorOnFocus() {
        publicStore.PublicHelpers.ServerError = "";
        v$.value.Msisdn.$reset();
    }

    async function validateForm(): Promise<void> {
        v$.value.$touch();
        let formValid = await v$.value.$validate();
        return new Promise((resolve) => {
            if (formValid) {
                resolve();
            }
        });
    };

    const validationRules = computed(() => ({
        Username: {
            required: errors.fieldRequired,
            isValidMsisdn: helpers.withMessage(i18n.global.t("GlobalErrors.MSISDN_FORMAT_INVALID"), () => publicStore.isUsernameNumber ? msisdnRegex.test(publicStore.Login.Username!) : true),
            isValidEmail: helpers.withMessage(i18n.global.t("GlobalErrors.EMAIL_FORMAT_INVALID"), () => !publicStore.isUsernameNumber ? emailRegex.test(publicStore.Login.Username!) : true)
        },
        Password: {
            required: errors.fieldRequired
        },
    }));

    const v$: any = useVuelidate(validationRules, publicStore.Login);

    const showPassword = ref(false);

</script>
